import { customElement } from 'lit/decorators.js'
import { BoardPlayerPage } from './board-player-page'

@customElement('app-board-player-page')
export class AppBoardPlayerPage extends BoardPlayerPage {
  get context() {
    return {
      title: super.context.title
    }
  }
}
